var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-list-item clearfix"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.newsHeadline)}}),_c('p',{key:_vm.languageKey,domProps:{"innerHTML":_vm._s(
            _vm.$options.filters.dateLongFormater(_vm.newsDate * 1000) +
            ' – ' +
            _vm.newsText
        )}}),_c('a',{staticClass:"button button-blue",attrs:{"href":_vm.newsHref,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('read_more')))])])}
var staticRenderFns = []

export { render, staticRenderFns }